import styled from 'styled-components';

import { TextInput } from '../text-input';

import back from './back.png';

import { crFont11, crFont13 } from '@controlrooms/web/src/app/global-styles';

export const Container = styled.div`
  background: ${({ theme }) => theme.datePickerv2.calendarBG};
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
  padding: 24px 24px 16px 24px;
  width: 320px;
  font-family: 'Open Sans', sans-serif;
`;

export const CalendarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.datePickerv2.label};
  margin-bottom: 12px;
  ${crFont13}
  font-weight: 600;
`;

export const NavButton = styled.button`
  width: 15px;
  height: 15px;
  border: none;
  background: url(${back});
  background-size: 15px;
  cursor: pointer;
  padding: 0 8px;
`;

export const PrevButton = styled(NavButton)``;
export const NextButton = styled(NavButton)`
  transform: rotate(180deg);
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 40px);
  grid-gap: 10px;
  justify-content: center;
  margin-bottom: 18px;
`;

export const DayCell = styled.div<{
  isSelected?: boolean;
  isToday?: boolean;
  isOtherMonth?: boolean;
}>`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  ${crFont11}
  background: ${({ isSelected, isToday, theme, isOtherMonth }) =>
    isOtherMonth
      ? `${theme.datePickerv2.cell}50`
      : isSelected
      ? theme.datePickerv2.cellSelected
      : isToday
      ? theme.datePickerv2.cell
      : 'transparent'};
    isSelected
      ? theme.datePickerv2.cellSelected
      : isToday
      ? theme.datePickerv2.cell
      : 'transparent'};
  color: ${({ isOtherMonth, theme }) =>
    isOtherMonth ? theme.datePickerv2.textInactive : theme.datePickerv2.textActive};
  border: 2px solid
    ${({ isSelected, theme }) =>
      isSelected ? theme.datePickerv2.cellSelectedBorder : theme.datePickerv2.cellBorder};
  font-weight: ${({ isSelected }) => (isSelected ? 700 : 400)};
  cursor: ${({ isOtherMonth }) => (isOtherMonth ? 'default' : 'pointer')};
  &:hover {
    background: ${({ theme, isOtherMonth }) =>
      isOtherMonth ? `${theme.datePickerv2.cell}50` : theme.datePickerv2.cellSelected}
`;

export const Weekdays = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 45px);
  justify-content: center;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.datePickerv2.label};
  font-size: 15px;
`;

export const TimeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 18px 0 0 0;
`;

export const TimeLabel = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.datePickerv2.label};
  margin-bottom: 4px;
`;

export const TimeInput = styled(TextInput)`
  width: 100px;
  margin-right: 8px;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  border-top: 1px solid ${({ theme }) => theme.datePickerv2.cellBorder};
  padding-top: 12px;
`;
